
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/hooks/useLanguage';
import { Check, X, AlertOctagon, ShieldAlert, Shield, ShieldCheck } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CVESeverityFilterProps {
  selectedSeverities: string[];
  onToggleSeverity: (severity: string) => void;
}

export function CVESeverityFilter({ selectedSeverities, onToggleSeverity }: CVESeverityFilterProps) {
  const { t, language } = useLanguage();

  // Updated severity filter buttons configuration with direct labels instead of translation keys
  const severityFilters = [
    {
      label: language === 'en' ? 'Critical' : 'Krytyczne',
      value: language === 'en' ? 'critical' : 'krytyczny',
      icon: AlertOctagon,
      color: 'red-700'
    },
    {
      label: language === 'en' ? 'High' : 'Wysokie',
      value: language === 'en' ? 'high' : 'wysoki',
      icon: ShieldAlert,
      color: 'amber-800'
    },
    {
      label: language === 'en' ? 'Medium' : 'Średnie',
      value: language === 'en' ? 'medium' : 'średni',
      icon: Shield,
      color: 'amber-500'
    },
    {
      label: language === 'en' ? 'Low' : 'Niskie',
      value: language === 'en' ? 'low' : 'niski',
      icon: ShieldCheck,
      color: 'emerald-500'
    },
  ];

  return (
    <div>
      <h3 className="text-lg font-medium mb-4">{t('cve.filter')}</h3>
      <div className="flex flex-wrap gap-2">
        {severityFilters.map(({ label, value, icon: Icon, color }) => {
          // Check if severity is selected in either language version
          const isSelected = selectedSeverities.includes(value.toLowerCase()) ||
            (language === 'en' && selectedSeverities.includes(value.toLowerCase().replace('critical', 'krytyczny').replace('high', 'wysoki').replace('medium', 'średni').replace('low', 'niski'))) ||
            (language === 'pl' && selectedSeverities.includes(value.toLowerCase().replace('krytyczny', 'critical').replace('wysoki', 'high').replace('średni', 'medium').replace('niski', 'low')));

          return (
            <Button
              key={value}
              variant="outline"
              size="sm"
              className={cn(
                "rounded-full border transition-all duration-300",
                isSelected
                  ? `bg-secondary border-${color} text-${color} shadow-sm`
                  : "bg-secondary/50 border-border text-muted-foreground hover:text-foreground hover:border-primary/50"
              )}
              onClick={() => onToggleSeverity(value)}
            >
              {isSelected ? (
                <Check className="h-3.5 w-3.5 mr-1" />
              ) : (
                <X className="h-3.5 w-3.5 mr-1" />
              )}
              <Icon className="h-4 w-4 mr-1" />
              {label}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
